<template>
  <footer>
    <nav class="navbar navbar-dark">
      <p>&copy;2021 yumenomatayume</p>
    </nav>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
nav {
  background: linear-gradient(30deg, rgb(177, 206, 219), rgb(18, 6, 128)) fixed;
  margin-top: 50px;
}
nav p {
  padding: 10px;
  margin: 0;
}
</style>
